import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { ThresholdStep } from '#src/components/pro/ThresholdStep/index.tsx';

import type { RewardsContent_taskCampaign } from './__generated__/index.graphql.ts';

type Props = { campain: RewardsContent_taskCampaign };

/**
 * The dialog previews the ladder without any per-user progress, so the lowest
 * step is presented as the one to aim for — as the Set invite dialog does.
 */
const REACHED_LEVEL = 1;

export const RewardsContent = ({ campain }: Props) => {
  const descendingSteps = [...campain.steps].reverse();

  return (
    <Vertical gap={2.5}>
      {descendingSteps.map((step, index) => {
        const level = descendingSteps.length - index;
        const leadsIntoReachedStep = level - 1 <= REACHED_LEVEL - 1;

        return (
          <ThresholdStep
            key={step.target}
            level={level}
            target={step.target}
            locked={level > REACHED_LEVEL}
            active={level === REACHED_LEVEL}
            animationOrder={descendingSteps.length - 1 - index}
            rewardConfigs={step.rewardConfigs}
            tailColor={leadsIntoReachedStep ? undefined : 'var(--c-nl-500)'}
          />
        );
      })}
    </Vertical>
  );
};

RewardsContent.fragments = {
  taskCampaign: gql`
    fragment RewardsContent_taskCampaign on TaskCampaign {
      slug
      steps {
        target
        rewardConfigs {
          id
          ...ThresholdStep_rewardConfig
        }
      }
    }
    ${ThresholdStep.fragments.rewardConfig}
  ` as TypedDocumentNode<RewardsContent_taskCampaign>,
};
